// extracted by mini-css-extract-plugin
export default {"HorizontalCollapseIcon--isCollapsed":"CollapseIcon_HorizontalCollapseIcon--isCollapsed__CmLgc"};